api = require('../api.coffee').api()

class global.ReportsResource extends ResourceBase

  constructor: (company_id) ->
    @company_id = company_id

  basePath: ->
    "/companies/#{@company_id}/reports"

  opportunityLost: (success, failure, params = {}) ->
    api.get "#{@basePath()}/opportunity_lost", params, { success, failure }

  countTasks: (success, failure, params = {}) ->
    api.get "#{@basePath()}/count_tasks", params, { success, failure }

  liveFeedEvents: (success, failure, params={}) ->
    success_callback = new ContactEventsResource().collectionSuccess(success)
    api.get "#{@basePath()}/live_feed_events", params, { success: success_callback, failure }

  funnel: (success, failure, params={}) ->
    api.get "#{@basePath()}/funnel", params, { success, failure }

  topStatisticable: (success, failure, params={}) ->
    api.get "#{@basePath()}/top_statisticable", params, { success: @topStatisticableSuccessCallback(success), failure }

  topStatisticableSuccessCallback: (success) ->
    (data) =>
      if data.body.flows
        new FlowsResource().collectionSuccess(success)(data)
      else if data.body.templates
        new TemplatesResource().collectionSuccess(success)(data)
      else
        success(data)

  groupedDoneTasks: (success, failure, params = {}) ->
    api.get "#{@basePath()}/grouped_done_tasks", params, { success, failure }



// WEBPACK FOOTER //
// ./src/resources/reports.coffee